/**
 * Review tab — student grid + design thumbnail placeholder.
 *
 * Placeholder content. Real implementation pulls student_design rows
 * for the teacher's classrooms and renders the thumbnails server-side
 * via R2.
 */
export function ReviewTab(): JSX.Element {
  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-900">Review</h1>
      <p className="mt-1 text-sm text-slate-600">
        Each student's latest design across your classrooms.
      </p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: stable placeholder layout
            key={i}
            className="aspect-square rounded-2xl border border-amber-100 bg-white p-3 shadow-sm"
          >
            <div className="grid h-full place-items-center rounded-xl bg-amber-50 text-xs uppercase tracking-wide text-amber-600">
              Thumbnail
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
